"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constant = require("../Theme/constant");
var _constant2 = require("./constant");
var _default = {
  PropTypes: {
    theme: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    customProperties: _propTypes.default.object,
    price: _propTypes.default.shape({
      amount: _propTypes.default.number.isRequired,
      currency: _propTypes.default.string.isRequired
    }).isRequired,
    guest: _propTypes.default.number,
    handleClick: _propTypes.default.func.isRequired,
    handleViewClick: _propTypes.default.func,
    horizontal: _propTypes.default.bool,
    customGuestText: _propTypes.default.string,
    customDetailText: _propTypes.default.string,
    customIconSize: _propTypes.default.string,
    translation: _propTypes.default.shape({
      ctaText: _propTypes.default.string,
      guest: _propTypes.default.string,
      details: _propTypes.default.string,
      percentageDiscount: _propTypes.default.string
    }),
    viewIcon: _propTypes.default.string,
    viewIconText: _propTypes.default.string,
    viewIconColor: _propTypes.default.string,
    locale: _propTypes.default.string,
    loading: _propTypes.default.bool,
    disabled: _propTypes.default.bool,
    defaultDisabledFeatures: _propTypes.default.bool,
    isSelected: _propTypes.default.bool,
    showButton: _propTypes.default.bool,
    ctaPosition: _propTypes.default.string,
    strikethroughPrice: _propTypes.default.number,
    percentageDiscount: _propTypes.default.number,
    customPercentageDiscountText: _propTypes.default.string,
    promoTags: _propTypes.default.arrayOf(_propTypes.default.string),
    showCurrency: _propTypes.default.bool,
    isSoldOut: _propTypes.default.bool,
    discountValue: _propTypes.default.number
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    customProperties: {},
    price: {},
    handleClick: function handleClick() {},
    handleViewClick: function handleViewClick() {},
    horizontal: true,
    translation: _constant2.TRANSLATION,
    customGuestText: null,
    customDetailText: null,
    customIconSize: null,
    ctaPosition: 'center',
    viewIcon: 'ExpandMoreIcon',
    viewIconColor: 'greyDark',
    loading: false,
    disabled: false,
    defaultDisabledFeatures: false,
    isSelected: false,
    showButton: true,
    strikethroughPrice: null,
    percentageDiscount: null,
    customPercentageDiscountText: '',
    showCurrency: false,
    isSoldOut: false,
    discountValue: null
  }
};
exports.default = _default;